export const EXT_LINK_ENV_CONTEXT = 'extLinkEnv';
export const EXT_LINK_NAMESPACE = 'extLinkEnv';
